<template>
<div
              class="input-errors"
              v-for="(error, index) of errors"
              :key="index"
              style="margin-top:4px;"
            >
              <div class="error-msg" v-if="error.field == field">{{ error.msg }}</div>
            </div>

</template>

<script>
export default {
  name: "Error",
  props: {
    field: String,
    msg: String,
    errors: Array,
  },
}
</script>

<style scoped>
.alert-danger {
    padding:3px;
    margin-top:2px;
}
.error-msg {
    border:1px solid red;
        border-radius: 3px;
    background:red;
    padding:3px;
  color: white;
  font-size: 13px;
}

</style>
